<template>
  <nav>
      <ul class="navigation">
        <router-link v-for="(route, i) in menu" :key="i"
          :to="route.link"
          class="navigation__item">
            {{ route.name }}
        </router-link>
      </ul>
    </nav>    
</template>

<script>
export default {
  name: 'AppNavigation',
  data: () => ({
    menu: [
      { link: '/', name: 'Amway.ru' },
      { link: '/kz', name: 'Amway.kz' },
      // { link: '/ua', name: 'Amway.ua' },
      { link: '/app', name: 'Amway App' },
      { link: '/start', name: 'Amway Start' },
    ]
  }),
}
</script>

<style lang="scss" scoped>
  .navigation {
    display: flex;
    background: #FFFFFF;

    .disabled {
        pointer-events: none;
        opacity: .5;
    }

    &__item {
      padding: 6px 30px 9px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      cursor: pointer;
      box-sizing: border-box;
      margin-right: 2px;
      border: 1px solid transparent;
      color: #000000;
      width: 155px;
      text-align: center;

      &:hover {
        border: 1px solid #034580;
        box-sizing: border-box;
        border-radius: 53px;
        color: #034580;
      }
    }

    a {
      text-decoration: inherit;
    }

    .router-link-exact-active {
      border: 1px solid #034580;
      box-sizing: border-box;
      padding: 6px 29px 9px;
      border-radius: 53px;
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;
      color: #034580;
      pointer-events: none;
    }
  }

</style>